import styled from 'styled-components';
import { paragraph } from '../../../../../theme/typography';

export const Summary = styled.p`
  ${paragraph};
  margin-bottom: 28px;
  text-align: left;
`;
